"use strict";

exports.__esModule = true;
exports.default = void 0;
var _tailwindClasses = require("./tailwindClasses");
const getOverflowClass = (overflow, viewport) => {
  if (!overflow) return null;
  return viewport ? _tailwindClasses.overflowClasses[viewport][overflow] : _tailwindClasses.overflowClasses[overflow];
};
var _default = exports.default = getOverflowClass;